export enum ReportType {
  Custom = "custom",
  TableAU = "tableAu",
}
